export type InAppBrowser =
    | 'facebook'
    | 'instagram'
    | 'tiktok'
    | 'twitter'
    | 'linkedin'
    | 'snapchat'
    | 'pinterest'
    | 'wechat'
    | 'line'
    | 'threads'
    | 'webview'
    | null

const IN_APP_BROWSER_PATTERNS: { pattern: RegExp; browser: InAppBrowser }[] = [
    { pattern: /FBAN|FBAV|FB_IAB|FBIOS|FBLC/i, browser: 'facebook' },
    { pattern: /Instagram/i, browser: 'instagram' },
    { pattern: /BytedanceWebview|TikTok/i, browser: 'tiktok' },
    { pattern: /Twitter|X.com/i, browser: 'twitter' },
    { pattern: /LinkedIn/i, browser: 'linkedin' },
    { pattern: /Snapchat/i, browser: 'snapchat' },
    { pattern: /Pinterest/i, browser: 'pinterest' },
    { pattern: /MicroMessenger/i, browser: 'wechat' },
    { pattern: /Line\//i, browser: 'line' },
    { pattern: /Barcelona/i, browser: 'threads' },
]

const GENERIC_WEBVIEW_PATTERN = /WebView|wv\)|; wv\)/i

export function detectInAppBrowser(userAgent?: string): InAppBrowser {
    const ua = userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '')
    if (!ua) return null

    for (const { pattern, browser } of IN_APP_BROWSER_PATTERNS) {
        if (pattern.test(ua)) return browser
    }

    if (GENERIC_WEBVIEW_PATTERN.test(ua)) return 'webview'

    return null
}
